// extracted by mini-css-extract-plugin
export var clickAwayListener = "_6f-6";
export var dividerBottom = "_6f-5";
export var dividerRight = "_6f-4";
export var horizontal = "_6f-1";
export var item = "_6f-3";
export var main = "_6f-0";
export var vertical = "_6f-2";